import { Action, PlainObject, State } from "@zyzgroup/core-common";

function reduce(state: State, payload: PlainObject): State {
  state.theme = payload?.theme || state?.theme || "light";
  return state;
}

export default (immutable = true) =>
  (state: State, action: Action) => {
    const nextState: State = immutable ? { ...state } : state;
    const payload = action.payload || {};
    switch (action.type) {
      case "SET_THEME":
      case "INIT":
        // 初始化
        reduce(nextState, payload);
        break;
    }
    return nextState;
  };
